// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import ArchiveAnimationController from './archive_animation_controller'

import ArchiveCardsController from './archive_cards_controller'

import ArchiveTodosController from './archive_todos_controller'

import AutoSaveController from './auto_save_controller'

import AutosizeController from './autosize_controller'

import BlogController from './blog_controller'

import BuildProgressController from './build_progress_controller'

import BulkCardsController from './bulk_cards_controller'

import BulkTodosController from './bulk_todos_controller'

import CardTransferingController from './card_transfering_controller'

import ClearOfflineCacheController from './clear_offline_cache_controller'

import ClipboardController from './clipboard_controller'

import ComboboxClearController from './combobox_clear_controller'

import CompanionAiAccordionController from './companion_ai_accordion_controller'
import CompanionAiCarouselController from './companion_ai_carousel_controller'
import CompanionLauncherController from './companion_launcher_controller'
import CompanionTickerController from './companion_ticker_controller'
import CompanionKeyBurstController from './companion_key_burst_controller'
import CompanionCallbackController from './companion_callback_controller'

import DateSourceController from './date_source_controller'
import DestinationEditorController from './destination_editor_controller'
import DialogController from './dialog_controller'

import DockEnablerController from './dock_enabler_controller'

import DomainSelectController from './domain_select_controller'

import ExpanderController from './expander_controller'

import FieldRowController from './field_row_controller'

import FormCardColumnController from './form_card_column_controller'

import FormCreateController from './form_create_controller'

import FormFieldsController from './form_fields_controller'

import FormMessageBoardController from './form_message_board_controller'

import FormScheduleController from './form_schedule_controller'

import FormTargetController from './form_target_controller'

import FormTodolistController from './form_todolist_controller'

import InlineArchiveController from './inline_archive_controller'

import InstantSubmitController from './instant_submit_controller'

import KanbanBoardController from './kanban_board_controller'

import KanbanColumnController from './kanban_column_controller'

import LexxyFieldController from './lexxy_field_controller'

import LineupMarkersController from './lineup_markers_controller'

import MessageArchivingController from './message_archiving_controller'

import MessageBroadcastingController from './message_broadcasting_controller'

import OptionsListController from './options_list_controller'

import PublishCoachmarkController from './publish_coachmark_controller'

import QuestionPickerController from './question_picker_controller'

import RepositoriesController from './repositories_controller'

import RevealController from './reveal_controller'

import SelectAllController from './select_all_controller'

import SaveFlashController from './save_flash_controller'
import SidebarController from './sidebar_controller'

import SortListController from './sort_list_controller'

import SpinnerController from './spinner_controller'

import SuccessCheckController from './success_check_controller'

import SuccessModeController from './success_mode_controller'

import ToastController from './toast_controller'

import ToggleInputController from './toggle_input_controller'

import TokenFieldController from './token_field_controller'

import TypewriterController from './typewriter_controller'

import UploadPreviewController from './upload_preview_controller'

import ValueCounterController from './value_counter_controller'

// Manual third-party registration — re-add if the manifest task strips it.
import HwComboboxController from '@josefarias/hotwire_combobox'

application.register('archive-animation', ArchiveAnimationController)
application.register('archive-cards', ArchiveCardsController)
application.register('archive-todos', ArchiveTodosController)
application.register('auto-save', AutoSaveController)
application.register('autosize', AutosizeController)
application.register('blog', BlogController)
application.register('build-progress', BuildProgressController)
application.register('bulk-cards', BulkCardsController)
application.register('bulk-todos', BulkTodosController)
application.register('card-transfering', CardTransferingController)
application.register('clear-offline-cache', ClearOfflineCacheController)
application.register('clipboard', ClipboardController)
application.register('combobox-clear', ComboboxClearController)
application.register('companion-ai-accordion', CompanionAiAccordionController)
application.register('companion-ai-carousel', CompanionAiCarouselController)
application.register('companion-launcher', CompanionLauncherController)
application.register('companion-ticker', CompanionTickerController)
application.register('companion-key-burst', CompanionKeyBurstController)
application.register('companion-callback', CompanionCallbackController)
application.register('date-source', DateSourceController)
application.register('destination-editor', DestinationEditorController)
application.register('dialog', DialogController)
application.register('dock-enabler', DockEnablerController)
application.register('domain-select', DomainSelectController)
application.register('expander', ExpanderController)
application.register('field-row', FieldRowController)
application.register('form-card-column', FormCardColumnController)
application.register('form-create', FormCreateController)
application.register('form-fields', FormFieldsController)
application.register('form-message-board', FormMessageBoardController)
application.register('form-schedule', FormScheduleController)
application.register('form-target', FormTargetController)
application.register('form-todolist', FormTodolistController)
application.register('inline-archive', InlineArchiveController)
application.register('instant-submit', InstantSubmitController)
application.register('kanban-board', KanbanBoardController)
application.register('kanban-column', KanbanColumnController)
application.register('lexxy-field', LexxyFieldController)
application.register('lineup-markers', LineupMarkersController)
application.register('message-archiving', MessageArchivingController)
application.register('message-broadcasting', MessageBroadcastingController)
application.register('options-list', OptionsListController)
application.register('publish-coachmark', PublishCoachmarkController)
application.register('question-picker', QuestionPickerController)
application.register('repositories', RepositoriesController)
application.register('reveal', RevealController)
application.register('select-all', SelectAllController)
application.register('save-flash', SaveFlashController)
application.register('sidebar', SidebarController)
application.register('sort-list', SortListController)
application.register('spinner', SpinnerController)
application.register('success-check', SuccessCheckController)
application.register('success-mode', SuccessModeController)
application.register('toast', ToastController)
application.register('toggle-input', ToggleInputController)
application.register('token-field', TokenFieldController)
application.register('typewriter', TypewriterController)
application.register('upload-preview', UploadPreviewController)
application.register('value-counter', ValueCounterController)
application.register('hw-combobox', HwComboboxController)
